// extracted by mini-css-extract-plugin
export default {"productGrid":"VY-z","centerLink":"WY-z","productSection":"XY-z","item":"YY-z","ctaButton":"ZY-z"};